import { Outlet } from 'react-router-dom'
import { Grid, GridItem, useBreakpointValue } from '@chakra-ui/react'
import { DESKTOP_SIDEBAR_WIDTH_SM, DESKTOP_SIDEBAR_WIDTH_XL } from '../../constants'
import DesktopMenu from '../SidebarNav/DesktopMenu'
import NotificationBanner from '../../Features/NotificationBanner/NotificationBanner'
import MobileMenu from '../SidebarNav/MobileMenu'
import { useEffect, useState } from 'react'

export function ReactRouterLayout() {
  // State to track if we've determined the view size
  const [viewSizeReady, setViewSizeReady] = useState(false)
  
  // This will be true only on small screens (below md breakpoint)
  const isMobileView = useBreakpointValue({ base: true, md: false })
  
  // Only mark the view size as ready once isMobileView has stabilized
  useEffect(() => {
    if (isMobileView !== undefined) {
      setViewSizeReady(true)
    }
  }, [isMobileView])
  return (
    <Grid
      templateColumns={{
        base: '1fr', // On the smallest screens, only one column
        md: `${DESKTOP_SIDEBAR_WIDTH_SM} 1fr`, // On larger screens (from lg) use a narrow sidebar
        xl: `${DESKTOP_SIDEBAR_WIDTH_XL} 1fr`, // On extra-large screens, use a wider sidebar
      }}
      templateRows="auto 1fr 1fr"
      minHeight="100vh"
      width="100%"
    >
      <GridItem
        width={{ base: '0px', md: DESKTOP_SIDEBAR_WIDTH_SM, xl: DESKTOP_SIDEBAR_WIDTH_XL }}
        display={{ base: 'none', md: 'block', xl: 'block' }}
      >
        <DesktopMenu reactRouterEntryNode={true} />
      </GridItem>

      <GridItem display={{ base: 'block', md: 'none' }}>
        {viewSizeReady && isMobileView && <MobileMenu reactRouterEntryNode={true}/>}
      </GridItem>

      <GridItem colSpan={{ base: 2, md: 1 }}>
        <GridItem colSpan={2}>
          <NotificationBanner />
        </GridItem>

        <GridItem colSpan={2}>
          <Outlet />
        </GridItem>
      </GridItem>
    </Grid>
  )
}
